import styled from 'styled-components';
import { TextBtn } from 'components';

export const Section = styled.section`
  padding: 1rem;
`;

export const Li = styled.li`
  padding-top: 1rem;
`;

export const StyledTextBtn = styled(TextBtn)`
  margin-top: 1rem;
`;
